import { State } from '.';
import { ImagingFacility } from '../../models/imaging-facility';

export const selectors = {
    getImagingFacility: (
        state: State,
        id: Undefinable<number>
    ): Undefinable<ImagingFacility> => state.byId[id || ''],
    getImagingFacilityIds: (
        state: State
    ): number[] => state.allIds
};
